import { getChainPublicApi } from 'api/apiCoreSdk';
import { displayWarningNotification } from 'components/layout/notifications/notificationsUtils';
import { setReferralCode } from 'reduxState/currentUserData/userReferral';
import { staticDispatch } from 'reduxState/store';

export async function fetchReferralCodeValidityAndShowToasts(code: string) {
  console.log('[ReferralAccessRedirectPage] Checking if code is valid');
  return getChainPublicApi()
    .getPublicReferralCodeValidity(code)
    .then(({ isValid }) => {
      console.log('[referralUtils] isValid', isValid);
      if (isValid) {
        // staticDispatch(setReferralIsValid());
        return true;
      } else {
        staticDispatch(setReferralCode(undefined));
        displayWarningNotification('Invalid referral code');
        return false;
      }
    })
    .catch(error => {
      console.warn(error);
      staticDispatch(setReferralCode(undefined));
      displayWarningNotification(error.message);
      return false;
    });
}
